<template>
  <div class="container flex-col flex-center">
    <div style="font-size:120px;font-family:consolas;">{{state}}</div>
    <div>{{desc}}</div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: ['state', 'desc'],
};
</script>
